import React from 'react'
import { makeStyles, createStyles, Box } from '@material-ui/core'
import { SERVICE_PHONE, SERVICE_WHATSAPP, SITE_MATE_DATA, SERVICE_EMAIL } from 'src/utils/constant'
import { useHistory, useRouteMatch } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Logo from 'src/mobile/assets/images/take2_white_orange.png'
import { ReactComponent as footerIcon1 } from 'src/mobile/assets/icons/footer_icon1.svg'
import { ReactComponent as footerIcon2 } from 'src/mobile/assets/icons/footer_icon2.svg'
import { ReactComponent as footerIcon3 } from 'src/mobile/assets/icons/footer_icon3.svg'
import { ReactComponent as footerIcon4 } from 'src/mobile/assets/icons/footer_icon4.svg'
import { ReactComponent as footerIcon5 } from 'src/mobile/assets/icons/footer_icon5.svg'
import { ReactComponent as footerIcon6 } from 'src/mobile/assets/icons/footer_icon6.svg'
import { ReactComponent as FooterIcon8 } from 'src/mobile/assets/icons/footer_icon8.svg'
import { buttonClick } from 'src/utils/trackingCode'
// import GoToTop from './GoToTop'
const useStyles = makeStyles((theme) =>
  createStyles({
    root: {},
    boxContainer: {
      position: 'relative',
      height: theme.spacing(89.875),
      lineHeight: '150%',
    },
    boxContainerTop: {
      backgroundColor: '#11378D',
      height: theme.spacing(89.875),
      color: '#FFFFFF',
      fontWeight: 400,
      fontSize: 16,
      // marginTop: theme.spacing(2),
      paddingLeft: theme.spacing(3),
    },
    logo: {
      width: theme.spacing(18.5),
      height: theme.spacing(5),
      marginTop: theme.spacing(5),
      marginBottom: theme.spacing(3),
    },
    icon8: {
      marginLeft: theme.spacing(0.5),
      marginTop: theme.spacing(-0.25),
    },
    list: {
      '&:last-child': {
        fontWeight: 500,
      },
    },
    redBox: {
      width: theme.spacing(0.75),
      height: theme.spacing(0.75),
      backgroundColor: '#F2512D',
      marginRight: theme.spacing(0.5),
    },
  }),
)
const Footer = () => {
  const { t, i18n } = useTranslation()
  const classes = useStyles()
  const history = useHistory()
  const isOrder = useRouteMatch(`/${i18n.language}/profile/order`)
  const isClinic = useRouteMatch(`/${i18n.language}/clinic/`)
  const FooterTopText = [
    {
      label: t('glossary.homepage'),
      path: '/',
    },
    {
      label: t('glossary.product_list'),
      path: '/ProductList',
    },
    {
      label: t('glossary. promotion_discount'),
      path: '/promotion',
    },
    {
      label: t('glossary.faq'),
      path: '/faq',
    },
    {
      label: t('glossary.web'),
      path: 'https://take2health.net/',
      otherWeb: true,
      icon: FooterIcon8,
    },
  ]

  const FooterText = [
    {
      label: t('glossary.contact_us'),
      FooterText: [
        {
          label: SERVICE_PHONE,
          icon: footerIcon1,
          toTel: true,
          number:
            SERVICE_PHONE.split(' ')[0].slice(1, 5) +
            SERVICE_PHONE.split(' ')[1] +
            SERVICE_PHONE.split(' ')[2],
        },
        {
          label: SERVICE_WHATSAPP,
          icon: footerIcon2,
          toWhatsApp: true,
          number:
            i18n.language === 'zh-HK'
              ? SITE_MATE_DATA.WHATSAPP_PC_HK
              : i18n.language === 'en'
              ? SITE_MATE_DATA.WHATSAPP_PC_EN
              : SITE_MATE_DATA.WHATSAPP_PC_CN,
        },
        {
          label: SERVICE_EMAIL,
          icon: footerIcon3,
          toMail: true,
        },
      ],
    },
    {
      label: t('glossary.track_us'),
      FooterText: [
        {
          label: 'Facebook',
          icon: footerIcon4,
          openNew: true,
          url: SITE_MATE_DATA.FACEBOOK,
        },
        {
          label: 'Linkedin',
          icon: footerIcon5,
          openNew: true,
          url: SITE_MATE_DATA.LINKEDIN,
        },
        {
          label: 'Youtube',
          icon: footerIcon6,
          openNew: true,
          url: SITE_MATE_DATA.YOUTUBE,
        },
      ],
    },
  ]
  return (
    <Box className={classes.boxContainer}>
      {/* <Box
        position="absolute"
        height={40}
        width={40}
        boxShadow="0px 8px 24px rgba(63, 63, 63, 0.12)"
        borderRadius="100px"
        top={-45}
        right={20}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <GoToTop />
      </Box> */}
      <Box className={classes.boxContainerTop} mt={isOrder ? '40px' : isClinic ? '16px' : ''}>
        <img className={classes.logo} src={Logo} alt="logo" />
        <Box>
          <Box fontWeight={600} fontSize={14} display="flex">
            <Box className={classes.redBox} mt={0.75} />
            {t('glossary.list_of_websites')}
          </Box>
          <Box>
            {FooterTopText.map((item, index) => (
              <Box
                key={index}
                mt={2}
                fontWeight={600}
                onClick={() => {
                  item.path === 'https://take2health.net/' &&
                    buttonClick('EH_Footer_CorpSite', 'EH_Footer_CorpSite')
                  item.otherWeb ? window.open(item.path) : history.push(item.path)
                }}
              >
                {item.icon ? (
                  <Box display="flex">
                    <Box>{item.label}</Box>
                    <item.icon className={classes.icon8} />
                  </Box>
                ) : (
                  <Box mt={2.5}>{item.label}</Box>
                )}
              </Box>
            ))}
          </Box>
        </Box>
        <Box>
          {FooterText?.map((item, index) => (
            <Box key={index} className={classes.list}>
              <Box display="flex">
                <Box className={classes.redBox} mt={3.75} />
                <Box mt={3} fontWeight={600} fontSize={14}>
                  {item.label}
                </Box>
              </Box>
              <Box>
                {item?.FooterText?.map((item, index) => (
                  <Box
                    key={index}
                    mt={2.25}
                    display="flex"
                    onClick={() => {
                      const buttonName = item?.toTel
                        ? 'EH_Footer_Phone'
                        : item?.toWhatsApp
                        ? 'EH_Footer_WhatsApp'
                        : item?.toMail
                        ? 'EH_Footer_email'
                        : ''
                      const buttonId = item?.toTel
                        ? 'EH_Footer_Phone'
                        : item?.toWhatsApp
                        ? 'EH_Footer_WhatsApp'
                        : item?.toMail
                        ? 'EH_Footer_email'
                        : ''
                      buttonClick(buttonName, buttonId)
                      item.openNew
                        ? window.open(item.url)
                        : item.toTel
                        ? (window.location.href = `tel:${item.number}`)
                        : item.toWhatsApp
                        ? (window.location.href = item.number)
                        : (window.location.href = `mailto:${item.label}`)
                    }}
                  >
                    <item.icon />
                    <Box ml={1} mt={0.6}>
                      {' '}
                      {item.label}
                    </Box>
                  </Box>
                ))}
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  )
}

export default Footer
